// src/services/searchService.js
import api from './api'

export const searchService = {
	async search(query, filters = {}) {
		if (!query || query.length < 2) {
			return []
		}

		try {
			const response = await api.get('/search', {
				params: {
					q: query,
					...filters,
					limit: 10,
				},
			})
			if (!response || !Array.isArray(response.results)) {
				return []
			}
			return response.results
		} catch (error) {
			console.error('[SearchService] Search API error:', error)
			// Возвращаем пустой массив при ошибке
			return []
		}
	},

	async getSuggestions(query) {
		try {
			const response = await api.get('/search/suggestions', {
				params: { q: query },
			})
			if (!response || !Array.isArray(response.suggestions)) {
				return []
			}
			return response.suggestions
		} catch (error) {
			return []
		}
	},

	async getPopular() {
		try {
			const response = await api.get('/search/popular')
			if (!response || !Array.isArray(response.items)) {
				return []
			}
			return response.items
		} catch (error) {
			// Возвращаем пустой массив если API недоступен
			return []
		}
	},
}
